/* FigurineMe theme scripts (no dependencies) */
(function () {
  'use strict';

  document.documentElement.classList.add('fm-js');
  var CFG = window.FM_CONFIG || {};

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || CFG.moneyFormat || '${{amount}}';
    function delimit(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ''); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(match[0], value);
  }
  window.FMformatMoney = formatMoney;

  /* ---------------- Delivery dates ---------------- */
  function addDays(date, days, skipWeekends) {
    var d = new Date(date.getTime());
    if (!skipWeekends) { d.setDate(d.getDate() + days); return d; }
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function fmtDate(d) {
    try {
      return d.toLocaleDateString(CFG.locale || undefined, { month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toDateString().slice(4, 10);
    }
  }
  function range(a, b) {
    var fa = fmtDate(a), fb = fmtDate(b);
    return fa === fb ? fa : fa + ' – ' + fb;
  }
  function initDelivery(root) {
    var now = new Date();
    var skip = !!CFG.skipWeekends;
    var sMin = Number(CFG.shipMin || 0), sMax = Math.max(sMin, Number(CFG.shipMax || 0));
    var dMin = Number(CFG.deliverMin || 0), dMax = Math.max(dMin, Number(CFG.deliverMax || 0));
    var vals = {
      today: fmtDate(now),
      ship: range(addDays(now, sMin, skip), addDays(now, sMax, skip)),
      deliver: range(addDays(now, dMin, skip), addDays(now, dMax, skip))
    };
    (root || document).querySelectorAll('[data-fm-date]').forEach(function (el) {
      var k = el.getAttribute('data-fm-date');
      if (vals[k]) el.textContent = vals[k];
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealObserver.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;
  function initReveal(root) {
    (root || document).querySelectorAll('.fm-reveal:not(.is-in), .fm-sizes__stage:not(.is-in)').forEach(function (el) {
      if (revealObserver) revealObserver.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------------- Product ---------------- */
  class FMProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var json = this.querySelector('[data-fm-product-json]');
      if (!json) return;
      try { this.product = JSON.parse(json.textContent); } catch (e) { return; }
      this.form = this.querySelector('form.fm-pform');
      this.variantInput = this.querySelector('[data-fm-variant-input]');
      this.track = this.querySelector('[data-fm-track]');
      this.isFeatured = this.hasAttribute('data-featured');

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-fm-option-input]')) this.onOptionChange();
      });
      this.querySelectorAll('[data-fm-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => this.goToMedia(btn.getAttribute('data-fm-thumb')));
      });
      var prev = this.querySelector('[data-fm-prev]'), next = this.querySelector('[data-fm-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));
      if (this.track) {
        var t;
        this.track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => this.syncThumbs(), 80); }, { passive: true });
      }
      this.querySelectorAll('[data-fm-qty]').forEach((b) => {
        b.addEventListener('click', () => {
          var input = this.querySelector('.fm-qty input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-fm-qty'), 10));
        });
      });
      this.initSticky();
      this.syncRadiosFromVariant();
      var v = this.currentVariant();
      this.updateDeltas();
      this.updateAvailability();
      if (v && v.featured_media) this.goToMedia(v.featured_media.id, true);
    }

    /* make sure the radios reflect the variant in the hidden input (source of truth) */
    syncRadiosFromVariant() {
      var id = this.variantInput && this.variantInput.value;
      var v = this.product.variants.find((x) => String(x.id) === String(id)) || this.product.variants[0];
      if (!v) return;
      this.querySelectorAll('[data-fm-option]').forEach((fs, i) => {
        var input = Array.from(fs.querySelectorAll('[data-fm-option-input]')).find((r) => r.value === v.options[i]);
        if (input) input.checked = true;
        var sel = fs.querySelector('[data-fm-selected]');
        if (sel) sel.textContent = v.options[i] || '';
      });
    }
    selectedOptions() {
      return Array.from(this.querySelectorAll('[data-fm-option]')).map((fs) => {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    findVariant(opts) {
      return this.product.variants.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i]));
    }
    currentVariant() {
      if (!this.querySelector('[data-fm-option]')) return this.product.variants[0];
      return this.findVariant(this.selectedOptions());
    }
    onOptionChange() {
      var opts = this.selectedOptions();
      this.querySelectorAll('[data-fm-option]').forEach((fs, i) => {
        var sel = fs.querySelector('[data-fm-selected]');
        if (sel) sel.textContent = opts[i] || '';
      });
      var v = this.findVariant(opts);
      this.updateDeltas();
      this.updateAvailability();
      var atc = this.querySelector('[data-fm-atc]');
      if (!v) {
        if (atc) { atc.disabled = true; atc.querySelector('[data-fm-atc-text]').textContent = 'Unavailable'; }
        return;
      }
      this.variantInput.value = v.id;
      this.form.querySelectorAll('input[name="id"]').forEach((i) => { i.value = v.id; });
      this.renderPrice(v);
      if (atc) {
        atc.disabled = !v.available;
        atc.querySelector('[data-fm-atc-text]').textContent = v.available ? atc.dataset.labelAdd : atc.dataset.labelSoldout;
      }
      if (v.featured_media) this.goToMedia(v.featured_media.id);
      if (!this.isFeatured && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      this.dispatchEvent(new CustomEvent('fm:variant-change', { bubbles: true, detail: { variant: v } }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
    }
    renderPrice(v) {
      this.querySelectorAll('[data-fm-price], [data-fm-atc-price]').forEach((el) => { el.textContent = formatMoney(v.price); });
      var cmp = this.querySelector('[data-fm-compare]');
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(v.compare_at_price); }
      var save = this.querySelector('[data-fm-save]');
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
          save.textContent = (save.dataset.template || 'Save [percent]').replace('[percent]', pct + '%');
        }
      }
    }
    /* "+$10" hints: price difference if this value were chosen, keeping other choices */
    updateDeltas() {
      var opts = this.selectedOptions();
      var current = this.findVariant(opts);
      if (!current) return;
      this.querySelectorAll('[data-fm-option]').forEach((fs, i) => {
        fs.querySelectorAll('[data-fm-option-input]').forEach((input) => {
          var delta = input.closest('.fm-pill').querySelector('[data-fm-delta]');
          if (!delta) return;
          if (input.checked) { delta.textContent = ''; return; }
          var test = opts.slice(); test[i] = input.value;
          var v = this.findVariant(test);
          if (!v) { delta.textContent = ''; return; }
          var diff = v.price - current.price;
          delta.textContent = diff === 0 ? '' : (diff > 0 ? '+' : '−') + formatMoney(Math.abs(diff));
        });
      });
    }
    updateAvailability() {
      var opts = this.selectedOptions();
      this.querySelectorAll('[data-fm-option]').forEach((fs, i) => {
        fs.querySelectorAll('[data-fm-option-input]').forEach((input) => {
          var test = opts.slice(); test[i] = input.value;
          var v = this.findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    /* gallery */
    slides() { return this.track ? Array.from(this.track.children) : []; }
    goToMedia(id, instant) {
      var slide = this.slides().find((s) => s.getAttribute('data-media-id') == String(id));
      if (!slide || !this.track) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      this.setActiveThumb(String(id));
    }
    step(dir) {
      if (!this.track) return;
      var w = this.track.clientWidth;
      var idx = Math.round(this.track.scrollLeft / w) + dir;
      var n = this.slides().length;
      idx = (idx + n) % n;
      this.track.scrollTo({ left: idx * w, behavior: 'smooth' });
    }
    syncThumbs() {
      if (!this.track) return;
      var idx = Math.round(this.track.scrollLeft / this.track.clientWidth);
      var slide = this.slides()[idx];
      if (slide) this.setActiveThumb(slide.getAttribute('data-media-id'));
    }
    setActiveThumb(id) {
      this.querySelectorAll('[data-fm-thumb]').forEach((t) => {
        var on = t.getAttribute('data-fm-thumb') === id;
        t.classList.toggle('is-active', on);
        if (on && t.parentElement) {
          var p = t.parentElement;
          var l = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
          p.scrollTo({ left: l, behavior: 'smooth' });
        }
      });
    }

    /* mobile sticky bar: shows once the buy button has scrolled out of view (hidden again near the footer) */
    initSticky() {
      var bar = this.querySelector('[data-fm-sticky]');
      var buy = this.querySelector('[data-fm-buy]') || this.form;
      if (!bar || !buy) return;
      var section = this.closest('section') || this;
      var ticking = false;
      var update = () => {
        ticking = false;
        var br = buy.getBoundingClientRect();
        var sr = section.getBoundingClientRect();
        var footer = document.querySelector('.fm-footer, footer');
        var footerIn = footer && footer.getBoundingClientRect().top < window.innerHeight;
        var show = br.bottom < 0 && sr.top < window.innerHeight && !footerIn;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b2 = bar.querySelector('[data-fm-sticky-btn]');
        if (b2) b2.tabIndex = show ? 0 : -1;
      };
      var onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
      var btn = bar.querySelector('[data-fm-sticky-btn]');
      if (btn) btn.addEventListener('click', () => {
        var target = this.querySelector('.fm-pinfo') || this.form;
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }
  }
  if (!customElements.get('fm-product')) customElements.define('fm-product', FMProduct);

  /* ---------------- Before / after slider ---------------- */
  class FMCompare extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var range = this.querySelector('.fm-compare__range');
      if (!range) return;
      var set = (v) => { this.style.setProperty('--pos', v + '%'); };
      set(range.value);
      range.addEventListener('input', () => { this.classList.remove('fm-hint-anim'); set(range.value); });
      range.addEventListener('pointerdown', () => this.classList.add('is-dragging'));
      ['pointerup', 'pointercancel', 'blur'].forEach((ev) => range.addEventListener(ev, () => this.classList.remove('is-dragging')));
      // gentle one-time hint when first seen
      if ('IntersectionObserver' in window && range.value == 50) {
        var io = new IntersectionObserver((es) => {
          es.forEach((e) => {
            if (e.isIntersecting) {
              this.style.removeProperty('--pos');
              this.classList.add('fm-hint-anim');
              this.addEventListener('animationend', () => { this.classList.remove('fm-hint-anim'); set(range.value); }, { once: true });
              io.disconnect();
            }
          });
        }, { threshold: 0.6 });
        io.observe(this);
      }
    }
  }
  if (!customElements.get('fm-compare')) customElements.define('fm-compare', FMCompare);

  /* ---------------- Infinite marquee ---------------- */
  class FMMarquee extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('.fm-marquee__track');
      this.group = this.querySelector('.fm-marquee__group');
      if (!this.track || !this.group || !this.group.children.length) return;
      this.build();
      var t;
      this._onResize = () => { clearTimeout(t); t = setTimeout(() => this.build(), 200); };
      window.addEventListener('resize', this._onResize);
      // recalc once images load
      this.group.querySelectorAll('img').forEach((img) => { if (!img.complete) img.addEventListener('load', this._onResize, { once: true }); });
    }
    disconnectedCallback() { if (this._onResize) window.removeEventListener('resize', this._onResize); }
    build() {
      this.track.querySelectorAll('.fm-marquee__group[aria-hidden]').forEach((g) => g.remove());
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 20;
      var groupW = this.group.getBoundingClientRect().width + gap;
      if (!groupW) return;
      var copies = Math.max(1, Math.ceil((window.innerWidth * 1.2) / groupW));
      for (var i = 0; i < copies; i++) {
        var clone = this.group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input').forEach((el) => el.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.track.appendChild(clone);
      }
      var speed = parseFloat(this.getAttribute('data-speed')) || 35;
      this.style.setProperty('--fm-shift', groupW + 'px');
      this.style.setProperty('--fm-duration', (groupW / speed).toFixed(1) + 's');
      this.classList.add('is-ready');
    }
  }
  if (!customElements.get('fm-marquee')) customElements.define('fm-marquee', FMMarquee);

  /* ---------------- Smooth in-page anchors with header offset ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('.section-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset + 1, behavior: 'smooth' });
    if (history.pushState) history.pushState(null, '', '#' + id);
  });

  /* ---------------- Boot ---------------- */
  function boot(root) { initDelivery(root); initReveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
